import React from "react";
import { FaUserSlash, FaEnvelope, FaTrashAlt, FaShieldAlt } from "react-icons/fa";

const DeleteAccount = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg,#f97316,#ea580c)",
        padding: "50px 20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#fff",
          borderRadius: "16px",
          padding: "40px",
          boxShadow: "0 10px 35px rgba(0,0,0,0.15)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <FaUserSlash size={60} color="#ea580c" />
          <h1 style={{ color: "#ea580c", marginTop: "15px" }}>
            Delete Your Hooks Delivery Partner Account
          </h1>

          <p style={{ color: "#555", fontSize: "18px" }}>
            We respect your privacy and your right to request deletion of your
            personal information.
          </p>
        </div>

        <div
          style={{
            background: "#fff7ed",
            borderLeft: "6px solid #ea580c",
            padding: "20px",
            borderRadius: "10px",
            marginBottom: "30px",
          }}
        >
          <h2 style={{ color: "#ea580c" }}>
            <FaTrashAlt /> How to Request Account Deletion
          </h2>

          <p>
            At this time, account deletion cannot be completed directly inside
            the Hooks Delivery Partner app.
          </p>

          <p>
            To permanently delete your courier account, please send an email to:
          </p>

          <h3 style={{ color: "#ea580c" }}>
            📧 noreply@getcoredispatch.cloud
          </h3>

          <p>Please include:</p>

          <ul>
            <li>Your registered email address.</li>
            <li>Your registered phone number.</li>
            <li>Your full name.</li>
            <li>The subject line: <strong>Delete My Account</strong></li>
          </ul>
        </div>

        <div
          style={{
            background: "#f8fafc",
            padding: "20px",
            borderRadius: "10px",
            marginBottom: "30px",
          }}
        >
          <h2 style={{ color: "#ea580c" }}>
            <FaShieldAlt /> What Happens After Your Request?
          </h2>

          <ul>
            <li>Your courier account will be permanently deleted.</li>
            <li>You will no longer be able to sign in.</li>
            <li>Your profile information will be removed from active use.</li>
            <li>
              Certain records (such as completed delivery records or information
              required for legal, tax, fraud prevention or regulatory
              compliance) may be retained where required by law.
            </li>
          </ul>
        </div>

        <div
          style={{
            background: "#eff6ff",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ color: "#ea580c" }}>
            <FaEnvelope /> Contact Support
          </h2>

          <p>
            If you have questions regarding your account or your personal data,
            contact us anytime.
          </p>

          <p>
            <strong>Email:</strong> noreply@getcoredispatch.cloud
          </p>

          <p>
            <strong>Website:</strong>{" "}
            <a
              href="https://getcoredispatch.cloud"
              target="_blank"
              rel="noreferrer"
            >
              https://getcoredispatch.cloud
            </a>
          </p>
        </div>

        <hr style={{ margin: "40px 0" }} />

        <p
          style={{
            textAlign: "center",
            color: "#777",
            fontSize: "14px",
          }}
        >
          © {new Date().getFullYear()} Hooks Delivery Partner. All Rights
          Reserved.
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;